import React from "react";

import { FpsService } from "@egis-smartcity/parking";

export type FpsState = {
  fpsService?: FpsService;
};

export const FpsContext = React.createContext<FpsState | undefined>(undefined);

export default FpsContext;
